// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__5VIAW","requiredAsterisk":"Info_requiredAsterisk__3dtMC"};